import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

const UpcLink = ({ rowData }: { rowData: any }) => {
  const query = rowData.receivingStoreId
    ? `?receivingStoreId=${rowData.receivingStoreId}`
    : "";
  const upc =
    rowData?.upc?.toString().replace(/^0+/, "") ||
    rowData?.UPC?.toString().replace(/^0+/, "");
  return (
    <Link to={`/product/${rowData.itemId}${query}`} aria-label="product">
      <Typography variant="subtitle2" color="primary.main">
        {upc}
      </Typography>
    </Link>
  );
};

export default UpcLink;
